
import React, { Component } from 'react';
import styles from './ProgressTalk.module.sass';
import PathContext from "../../context/path";
class ProgressTalk extends Component {


	state = {
		opened: false,
		offset: 0
	};

	refItems = React.createRef();
	refInner = React.createRef();

	static contextType = PathContext;
	path = this.context;

	componentDidMount() {
		if(window.innerWidth > 767){
			
			this.setState({
				offset: this.refItems.current.offsetWidth - this.refInner.current.offsetWidth 
			})
		}else{
		this.setState({
			offset: this.refItems.current.offsetWidth - window.innerWidth
		})
	}

	}
	componentWillUnmount() {
		// window.removeEventListener('scroll', this.setOffset.bind(this));
		if(window.innerWidth > 767){
			this.setState({
				offset: this.refItems.current.offsetWidth - this.refInner.current.offsetWidth 
			})
		}else{
		this.setState({
			offset: this.refItems.current.offsetWidth - window.innerWidth
		})
	}
	}

	// checkData(stage){


	// }
	// setOffset(){
	// 	console.log(this.state.offset);
	// 	console.log(this.props.progress);

	// 	document.querySelector('#talk-items').style.left = `-${this.state.offset * (this.props.progress / 100)}px`;

	// }
	render() {
		// document.querySelector('#talk-items').style.left = `-${this.state.offset * (this.props.progress / 100)}px`;
		let progress = this.props.progress;
		return (
			<>
				
				<div className={styles.wrap}>
				<div className={styles.inner} ref={this.refInner} >
					<div className={styles.items} ref={this.refItems} style={{ left: `-${this.state.offset * (progress / 100)}px` }}>
						<div className={styles.item}>
							<div className={styles.img}>
								<img src={`${this.path}/img/talk-img-1.png`} alt="" />
							</div>
							<div className={styles.title}>Find out the person’s attitude to the problem</div>
							<div className={styles.text}>
								<p>Before starting a conversation about an HIV test, find out from your partner what he or she thinks about the virus.</p>
								<p>Suggest that they read an article, discuss the statistics or share your own opinion. Share what you know about the “Undetectable = Untransmittable” principle, thanks to which you can plan for a family, even if one of the partners has HIV.</p>
								<p>And then get to the heart of the matter: “Maybe we should get tested?”</p>
							</div>
						</div>
						<div className={styles.item}>
							<div className={styles.img}>
								<img src={`${this.path}/img/talk-img-2.png`} alt="" />
							</div>
							<div className={styles.title}>Suggest taking the test together</div>
							<div className={styles.text}>
							<p>If you want to convince your partner to take the test, you have to be prepared to take it yourself. You can’t say “Why me? It’s obvious that I’m healthy,” or “You’ve had more sexual partners.”</p>
								<p>Say that it would make sense for you to get your health checked out and suggest that your partner come along. Usually people refuse because they’re afraid of finding out their results. But it’s easier to do together and when you know that HIV is no longer a threat to your life or to the lives of your family.</p>
							</div>
						</div>
						<div className={styles.item}>
							<div className={styles.img}>
								<img src={`${this.path}/img/talk-img-3.png `} alt="" />
							</div>
							<div className={styles.title}>Talk about your experience</div>
							<div className={styles.text}>
							<p>Share your plans to have your health checked out before starting a conversation about the test. Show that you’re genuinely interested in your health and that the procedure is no cause for concern.</p>
								<p>If you’ve recently taken the test, talk to your partner about the procedure and offer support. If over a year has passed since you took the test, you can take another.</p>
							</div>
						</div>
						<div className={styles.item}>
							<div className={styles.img}>
								<img src={`${this.path}/img/talk-img-4.png`} alt="" />
							</div>
							<div className={styles.title}>Convince them that it isn’t about trust</div>
							<div className={styles.text}>
							<p>When you suggest that your partner find out his or her HIV status, they might suspect that you doubt their love, their fidelity and their purity. Your job is to convince them that you’re just taking care of your future.</p>
								<p>Tell them that sex is one of the main ways that HIV can be transmitted, and that the virus can be undetected for many years. Not everybody is in the habit of taking care of their health, even if they know about diseases that can be sexually transmitted.</p>
							</div>
						</div>
						{/* <div className={styles.item}>
							<div className={styles.img}>
								<img src={`${this.path}/img/talk-img-5.png`} alt="" />
							</div>
							<div className={styles.title}>Не манипулируйте и не поддавайтесь на манипуляции</div>
							<div className={styles.text}>
								<p>Вы не имеете права заставлять партнера сдать анализ. Ни шантажом, ни угрозами о разрыве. Но и ваша половина должна считаться с вашими правами и желаниями.</p>
								<p>Не позволяйте склонить себя к незащищенному сексу. Даже если у вас уже был контакт без презерватива, вы могли не заразиться. И вновь подвергать себя опасности точно не стоит.</p>
								<p>Сдавать вашему партнёру анализы или нет — это его выбор. Принять это или нет — выбор ваш.</p>
							</div>
						</div> */}
					</div>
					</div>
				</div>
			</>
		);
	}
}

export default ProgressTalk;
